import { useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { useOidc } from '@preqin/preqin-core/cjs/OIDC/oidc.utils';

import { ErrorNotification, PageNotFoundErrorComponent } from './components/error';
import { PowerBiWorkspace } from './components/PowerBi';
import { getForbiddenWorkspaces } from './constants/workspaceNames';
import { usePowerBIContext } from './context/PowerBIContext';
import { User } from './types';

const Routes = ({ user }: { user: User }) => {
  const { login, logout, isAuthenticated } = useOidc();
  const [appLoaded, setAppLoaded] = useState(false);
  const location = useLocation();
  const { reportList, isLoadingReportList, reportListError } = usePowerBIContext();

  //handle logout
  useEffect(() => {
    if (location?.pathname === '/signout' || location?.pathname === '/logout') {
      return logout(window.location.pathname);
    }
  }, [location]);

  useEffect(() => {
    !isAuthenticated && login(window.location.pathname);
  }, [isAuthenticated]);

  useEffect(() => {
    if (!!user) {
      setAppLoaded(true);
    }
    if (user && user.id) {
      // HEAP
      if (window._env_.HEAP_ENABLED) {
        if (window.heap) {
          const FIRM_ID = 'Firm ID';
          const FIRM_TYPE = 'Firm Type ';
          window.heap.identify(user.contactFirmId);
          window.heap.addUserProperties({
            [FIRM_ID]: user.preqinFirmId,
            [FIRM_TYPE]: user.firmType,
            Subscriptions: user.subscriptions,
          });
        }
      }
    }
  }, [user]);

  if (appLoaded && !isLoadingReportList) {
    const userWorkspaces = reportList?.data?.workspaces?.map((w) => w.appPath);

    return (
      <Switch>
        {reportList?.data?.workspaces?.map((workspace) => (
          <Route path={workspace.appPath} key={workspace.workspaceName}>
            <PowerBiWorkspace workspace={workspace} />
          </Route>
        ))}

        {getForbiddenWorkspaces(userWorkspaces).map((workspace) => {
          return (
            <Route path={workspace.name} key={workspace.name}>
              <workspace.NoAccessComponent />
            </Route>
          );
        })}
        <Route exact={true} path={'/signout'} />
        <Route path="*">
          {/* @ts-ignore */}
          {reportListError && reportListError.response !== 404 && reportListError.response?.status !== 404 ? (
            <ErrorNotification error={reportListError} />
          ) : (
            <PageNotFoundErrorComponent />
          )}
        </Route>
      </Switch>
    );
  }
};

export default Routes;
